import { useState, useRef } from 'react';
import axios from 'axios';
import { UploadSimple, X } from '@phosphor-icons/react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const UpiQrUpload = ({ value, onChange }) => {
  const [uploading, setUploading] = useState(false);
  const [error, setError] = useState('');
  const fileRef = useRef(null);

  const onFile = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setError('');
    if (!['image/jpeg', 'image/png'].includes(file.type)) { setError('Use JPG or PNG'); return; }
    if (file.size > 5 * 1024 * 1024) { setError('Image must be under 5MB'); return; }

    setUploading(true);
    const fd = new FormData();
    fd.append('file', file);
    try {
      const { data } = await axios.post(`${API}/upload/upi-qr`, fd, {
        withCredentials: true,
        headers: { 'Content-Type': 'multipart/form-data' }
      });
      onChange(data.url);
    } catch (err) {
      setError(err.response?.data?.detail || 'Upload failed');
    } finally {
      setUploading(false);
      if (fileRef.current) fileRef.current.value = '';
    }
  };

  return (
    <div>
      <input
        ref={fileRef}
        type="file"
        accept="image/jpeg,image/png"
        onChange={onFile}
        className="hidden"
        data-testid="upi-qr-file-input"
      />
      {value ? (
        <div className="relative rounded-xl overflow-hidden border border-gray-200 inline-block">
          <img src={value} alt="UPI QR code" className="w-48 h-48 object-contain bg-white" data-testid="upi-qr-preview" />
          <button
            type="button"
            onClick={() => onChange('')}
            className="absolute top-2 right-2 bg-white/95 hover:bg-red-500 hover:text-white text-gray-700 p-2 rounded-lg transition-colors"
            data-testid="upi-qr-clear-btn"
          >
            <X size={14} weight="bold" />
          </button>
        </div>
      ) : (
        <button
          type="button"
          onClick={() => fileRef.current?.click()}
          disabled={uploading}
          className="w-full bg-gray-50 hover:bg-orange-50 border-2 border-dashed border-gray-200 hover:border-[#F97316] text-gray-500 hover:text-[#F97316] rounded-xl p-6 transition-colors flex flex-col items-center justify-center gap-2"
          data-testid="upi-qr-upload-btn"
        >
          <UploadSimple size={20} weight="bold" />
          <span className="text-sm font-semibold">{uploading ? 'Uploading...' : 'Upload UPI QR Code'}</span>
          <span className="text-xs text-gray-400">JPG or PNG — max 5MB</span>
        </button>
      )}
      {error && <p className="text-red-600 text-xs mt-2" data-testid="upi-qr-error">{error}</p>}
    </div>
  );
};

export default UpiQrUpload;
